import Vue from "vue";
import "@/plugins/bootstrap-vue";
// import "@/plugins/vue-markdown";
import "@/plugins/axios";
import "@/plugins/axiosEpdpApi";
import "@/plugins/modal-toast";
import "@/registerServiceWorker";
import router from "@/router/router";
import store from "@/store";
import App from "@/app/app.vue";
import VueMoment from "vue-moment";
import moment from "moment";
import "moment/locale/id";
import PageHeader from "@/components/common/page-header/page-header.vue";
import PiSelect from "@/components/common/pi-select/pi-select.vue";
import PiTable from "@/components/common/pi-table/pi-table.vue";
import PiSearch from "@/components/common/pi-search/pi-search.vue";
import PiSegments from "@/components/common/pi-segments/pi-segments.vue";

Vue.config.productionTip = false;
Vue.use(VueMoment, {
  moment,
});

// Shared design-system components — usable on any page
Vue.component("page-header", PageHeader);
Vue.component("pi-select", PiSelect);
Vue.component("pi-table", PiTable);
Vue.component("pi-search", PiSearch);
Vue.component("pi-segments", PiSegments);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
